export default class Price {
    constructor(minQuantity, maxQuantity, price) {
        this.minQuantity = minQuantity;
        this.maxQuantity = maxQuantity;
        this.price = price;
    }
}